export default __webpack_public_path__ + "static/media/bg2.d3885f9f.jpg";